<template>
  <div class="page flex flex-col w-1600px m-auto bg-white">
    <lists v-if="page === 'lists'" ref="lists" @listClick="listClick" />
    <detail
      v-if="page === 'detail'"
      :data="discussData"
      @back="page = 'lists'"
    />
    <Footer />
  </div>
</template>

<script>
import lists from './lists.vue'
import detail from './detail.vue'
import Footer from '@/components/layout/footer.vue'

export default {
  components: { lists, detail, Footer },
  props: { data: {} },
  data() {
    return {
      page: 'lists',
      discussData: {}
    }
  },
  created() {},
  mounted() {},
  methods: {
    listClick(data) {
      this.discussData = data
      this.page = 'detail'
    }
  }
}
</script>
<style lang="scss" scoped>

.page {
  min-height: calc(100vh - 290px);
  margin-top: 10px;
}

</style>
